module.exports = __webpack_public_path__ + "img/extension.cf9c7826.png";